import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class TextArea extends React.Component {
  static propTypes = {
    mode: PropTypes.oneOf(['info', 'success', 'danger', 'warning']),
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    mode: undefined,
    readOnly: false,
    disabled: false,
    className: undefined,
  };

  render() {
    const { mode, readOnly, disabled, className, ...props } = this.props;

    const inputClasses = clx(
      'text-area',
      {
        [`mode-${mode}`]: mode,
        readonly: readOnly,
        disabled,
      },
      className
    );

    return <textarea className={inputClasses} disabled={disabled} readOnly={readOnly} {...props} />;
  }
}
